import Header from '../global/Header';
import StudentChangePassword from '../components/ProfilePage/studentChangePassword';

export default function ChangePassword() {
    return (

        <>
            <Header/>
            <StudentChangePassword/>
        </>
    )
}
